<template>
  <div class="home-page" ref="scale">
    <div class="block">
      <div class="block-item" v-loading="loading">
        <div class="item-title">人员数据汇总</div>
        <div class="staff-chart">
          <div class="patient-num">
            <pie
              :data="patientNum"
              ref="pieChart"
              title="患者总数"
              idName="patientChart"
            ></pie>
            <!-- <pie
			  :data="4504"
			  ref="pieChart"
			  title="患者总数"
			  idName="patientChart"
			></pie> -->
          </div>
          <div class="patient-num">
            <pie
              :data="seeNum"
              ref="pieChart2"
              title="就诊次数"
              idName="seeChart"
              sourceType="2"
            ></pie>
          </div>
        </div>
        <div class="month-num">
          <div class="tab">
            <div
              class="tab-item"
              :class="{ active: activeName == 1 }"
              @click="changeTab(1)"
            >
              <div class="item-name">患者人数</div>
              <div class="line" v-if="activeName == 1"></div>
            </div>
            <div
              class="tab-item"
              :class="{ active: activeName == 2 }"
              @click="changeTab(2)"
            >
              <div class="item-name">就诊次数</div>
              <div class="line" v-if="activeName == 2"></div>
            </div>
          </div>
          <div class="detail">
            <div class="detail-item">
              本月累计<span class="num" v-if="countPatient.month">{{
                countPatient.month.number
              }}</span>
            </div>
            <div class="detail-item">
              环比<span class="num">{{ countPatient.chainRatio }}</span>
            </div>
            <div class="detail-item">
              本年累计<span class="num" v-if="countPatient.year">{{
                countPatient.year.number
              }}</span>
            </div>
            <div class="detail-item">
              同比<span class="num">{{ countPatient.commonRatio }}</span>
            </div>
          </div>
          <div class="month-bar">
            <bar
              :xAxisList="xAxisList"
              :yAxisList="yAxisList"
              idName="monthNum"
              ref="barChart"
            ></bar>
          </div>
        </div>
      </div>
      <div class="block-item">
        <div class="area-num">
          <hn-map-chart
            ref="mapChart"
            v-if="teamsId === '52c5af3085b64f51b932406efce5a6b3'"
            :data="mapList3"
          ></hn-map-chart>
          <map-chart :data="mapList" ref="mapChart" v-else></map-chart>
          <!-- <div class="color-list">
            <div class="item">
              <div class="item-bg"></div>
              <div class="item-text">0-200</div>
            </div>
          </div> -->
        </div>
      </div>
      <div class="block-item">
        <div class="block-top">
          <div class="item-title">治疗方案</div>
          <div class="tab-btns">
            <div
              class="btn"
              v-for="(item, index) in planList"
              :key="index"
              :class="{ active: planCheck == item.value }"
              @click="changePlan(item.value)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="plan-chart">
          <pie
            v-if="planCheck == 1"
            :data="allPlanList"
            ref="planPieChart"
            idName="allPlan"
            :isSolid="true"
          ></pie>
          <bar
            v-else
            :xAxisList="xAxisPlanList"
            :yAxisList="yAxisPlanList"
            idName="planBarChart"
            ref="planBarChart"
            :isOrientation="true"
            color="#1DD0DF"
          ></bar>
        </div>
      </div>
    </div>
    <div class="block">
      <div class="block-item block-item-2">
        <div class="block-top">
          <div class="item-title">疾病诊断</div>
          <div class="tab-btns">
            <div
              class="btn"
              v-for="(item, index) in diseaseList"
              :key="index"
              :class="{ active: diseaseCheck == item.value }"
              @click="changeDisease(item.value)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="echarts-box" :class="{ 'bar-width': diseaseCheck == 5 }">
          <div
            class="disease-pie-chart"
            id="diseasePieChart"
            v-if="diseaseCheck != 5"
          ></div>
          <bar
            v-else
            :xAxisList="xAxisWesternList"
            :yAxisList="yAxisWesternList"
            idName="westernBarChart"
            ref="westernBarChart"
            type="western"
          ></bar>
        </div>
      </div>
      <div class="block-item block-item-3" v-loading="dataListLoading">
        <div class="item-title">首页内容</div>
        <div class="information-list" v-if="informationList.length">
          <div
            class="list-item"
            v-for="(item, index) in informationList"
            :key="index"
            @click="handleViewInfo(item)"
          >
            <div class="date">{{ item.publishTime }}</div>
            <div class="title">{{ item.noticeTitle }}</div>
          </div>
        </div>
        <div class="no-data">暂无数据</div>
        <div class="more-btn" v-if="total > 8" @click="toInformation">
          查看更多
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pie from "./component/pie";
import bar from "./component/bar";
import mapChart from "./component/map";
import hnMapChart from "./component/hnMap";
import { myEchartsFontSize } from "@/utils";
export default {
  inject: ["refresh"],
  components: {
    pie,
    bar,
    mapChart,
    hnMapChart,
  },
  data() {
    return {
      patientNum: [],
      seeNum: [],
      year: "",
      loading: false,
      teamsId: "",
      doctorId: "",
      activeName: "1",
      countPatient: {}, //本年本月
      xAxisList: [], //横坐标
      yAxisList: [], //纵坐标
      month: [
        "一月",
        "二月",
        "三月",
        "四月",
        "五月",
        "六月",
        "七月",
        "八月",
        "九月",
        "十月",
        "十一月",
        "十二月",
      ],
      mapList: [
        { name: "宿州市", value: 1, list: [{ name: "萧县", value: 1 }] },
        { name: "淮北市", value: 301, list: [] },
        {
          name: "亳州市",
          value: 105,
          list: [
            { name: "谯城区", value: 2 },
            { name: "其他", value: 103 },
          ],
        },
        {
          name: "阜阳市",
          value: 210,
          list: [
            { name: "临泉县", value: 1 },
            { name: "太和县", value: 1 },
            { name: "其他", value: 208 },
          ],
        },
        {
          name: "淮南市",
          value: 19,
          list: [
            { name: "田家庵区", value: 2 },
            { name: "寿县", value: 1 },
            { name: "大通区", value: 1 },
            { name: "凤台县", value: 1 },
            { name: "其他", value: 14 },
          ],
        },
        { name: "滁州市", value: 205, list: [] },
        {
          name: "六安市",
          value: 335,
          list: [
            { name: "霍邱县", value: 2 },
            { name: "其他", value: 333 },
          ],
        },
        {
          name: "合肥市",
          value: 1322,
          list: [
            { name: "肥西县", value: 3 },
            { name: "蜀山区", value: 2 },
            { name: "庐阳区", value: 1 },
            { name: "庐江县", value: 1 },
            { name: "肥东县", value: 1 },
            { name: "包河区", value: 1 },
            { name: "其他", value: 1313 },
          ],
        },
        { name: "安庆市", value: 1, list: [{ name: "太湖县", value: 1 }] },
        { name: "芜湖市", value: 379, list: [] },
      ],
      mapList2: [
        { name: "徐州市", value: 1, list: [{ name: "萧县", value: 1 }] },
        { name: "连云港市", value: 301, list: [] },
        {
          name: "宿迁市",
          value: 105,
          list: [
            // { name: "谯城区", value: 2 },
            // { name: "其他", value: 103 },
          ],
        },
        {
          name: "淮安市",
          value: 210,
          list: [
            // { name: "临泉县", value: 1 },
            // { name: "太和县", value: 1 },
            // { name: "其他", value: 208 },
          ],
        },
        {
          name: "盐城市",
          value: 19,
          list: [],
        },
        { name: "扬州市", value: 205, list: [] },
        {
          name: "盐城市",
          value: 335,
        },
        {
          name: "南京市",
          value: 1322,
        },
        { name: "泰州市", value: 1, list: [] },
        { name: "镇江市", value: 379, list: [] },
        { name: "南通市", value: 120, list: [] },
        { name: "常州市", value: 58, list: [] },
        { name: "无锡市", value: 258, list: [] },
        { name: "苏州市", value: 1258, list: [] },
      ],
      mapList3: [
        { name: "龙亭区", value: 28 },
        { name: "禹王台区", value: 9 },
        { name: "顺河回族区", value: 16 },
        { name: "鼓楼区", value: 10 },
        { name: "祥符区", value: 42 },
        { name: "杞县", value: 58 },
        { name: "通许县", value: 34 },
        { name: "尉氏县", value: 52 },
        { name: "兰考县", value: 48 },
      ],
      planCheck: 1,
      planList: [
        { name: "全部", value: 1 },
        { name: "中药", value: 2 },
        { name: "西药", value: 3 },
        { name: "中成药", value: 4 },
        { name: "非药物", value: 5 },
      ],
      allPlanList: [
        { name: "中药人数", value: 240 },
        { name: "西药治疗", value: 241 },
        { name: "中成药治疗", value: 127 },
        { name: "其他药物治疗", value: 67 },
        { name: "非药物治疗", value: 270 },
      ], //治疗方案全部数据
      xAxisPlanList: [],
      yAxisPlanList: [],
      // 中药
      medicine: [
        { name: "丹参", value: 240 },
        { name: "川芎", value: 210 },
        { name: "黄芪", value: 195 },
        { name: "三七", value: 180 },
        { name: "山楂", value: 165 },
        { name: "当归", value: 150 },
        { name: "桂枝", value: 135 },
        { name: "瓜蒌皮", value: 120 },
        { name: "钩藤", value: 105 },
        { name: "茯苓", value: 195 },
      ],
      // 西药
      medicine2: [
        { name: "阿司匹林肠溶片", value: 240 },
        { name: "他汀类药物（如阿托伐他汀）", value: 225 },
        { name: "β受体阻滞剂（如美托洛尔）", value: 180 },
        { name: "ACEI/ARB类（如培哚普利、缬沙坦）", value: 210 },
        { name: "钙通道阻滞剂（如氨氯地平）", value: 150 },
        { name: "硝酸酯类（如单硝酸异山梨酯）", value: 105 },
        { name: "利尿剂（如呋塞米、氢氯噻嗪）", value: 90 },
        { name: "抗凝药（如华法林、利伐沙班）", value: 45 },
        { name: "降糖药（如二甲双胍、胰岛素）", value: 75 },
        { name: "质子泵抑制剂（如奥美拉唑）", value: 60 },
      ],
      // 中成药
      medicine3: [
        { name: "银杏叶片", value: 127 },
        { name: "复方丹参滴丸", value: 101 },
        { name: "通心络胶囊", value: 85 },
        { name: "麝香保心丸", value: 67 },
        { name: "速效救心丸", value: 80 },
        { name: "脑心通胶囊", value: 51 },
        { name: "益气复脉胶囊", value: 43 },
        { name: "注射用血塞通", value: 33 },
        { name: "舒血宁注射液", value: 18 },
        { name: "丹红注射液", value: 15 },
      ],
      // 非药物
      medicine4: [
        { name: "低盐低脂饮食指导", value: 270 },
        { name: "有氧运动处方（如快走、慢跑）", value: 210 },
        { name: "戒烟干预", value: 90 },
        { name: "限酒/戒酒指导", value: 120 },
        { name: "心理疏导/压力管理", value: 135 },
        { name: "体重管理计划", value: 180 },
        { name: "血压自我监测培训", value: 255 },
        { name: "心脏康复计划", value: 75 },
        { name: "睡眠健康教育", value: 165 },
        { name: "健康教育讲座/病友会", value: 150 },
      ],
      diseasePieChart: "",
      diseaseCheck: 1,
      diseaseList: [
        { name: "疾病类型", value: 1 },
        { name: "症状主诉", value: 2 },
        { name: "风险等级", value: 3 },
        { name: "关键指标达标率", value: 5 },
      ],
      diseasePieList: [
        {
          name: "高血压",
          value: 198,
          percentage: "66%",
          itemStyle: {
            normal: { color: "#6BE98A" },
            emphasis: { color: "#6BE98A" },
          },
        },
        {
          name: "冠心病",
          value: 102,
          percentage: "34%",
          note: "其中稳定性心绞痛约60人，心肌梗死病史约42人",
          itemStyle: {
            normal: { color: "#75F394" },
            emphasis: { color: "#75F394" },
          },
        },
        {
          name: "心律失常",
          value: 45,
          percentage: "15%",
          itemStyle: {
            normal: { color: "#9AD3FF" },
            emphasis: { color: "#9AD3FF" },
          },
        },
        {
          name: "心力衰竭",
          value: 33,
          percentage: "11%",
          itemStyle: {
            normal: { color: "#A4DDFF" },
            emphasis: { color: "#A4DDFF" },
          },
        },
        {
          name: "脑卒中",
          value: 24,
          percentage: "8%",
          itemStyle: {
            normal: { color: "#9096FF" },
            emphasis: { color: "#9096FF" },
          },
        },
        {
          name: "其他",
          value: 18,
          percentage: "6%",
          itemStyle: {
            normal: { color: "#787EF4" },
            emphasis: { color: "#787EF4" },
          },
        },
      ],
      diseaseSecPieList: [
        {
          name: "性心绞痛",
          value: 60,
          itemStyle: {
            normal: { color: "#6BE98A" },
            emphasis: { color: "#6BE98A" },
          },
        },
        {
          name: "心肌梗死",
          value: 42,
          itemStyle: {
            normal: { color: "#75F394" },
            emphasis: { color: "#75F394" },
          },
        },
      ],
      diseasePieList2: [
        {
          name: "胸闷",
          value: "80",
          itemStyle: {
            normal: { color: "#75F394" },
            emphasis: { color: "#75F394" },
          },
        },
        {
          name: "头晕",
          value: "65",
          itemStyle: {
            normal: { color: "#6AD3FF" },
            emphasis: { color: "#6AD3FF" },
          },
        },
        {
          name: "乏力",
          value: "60",
          iitemStyle: {
            normal: { color: "#4dcb6c" },
            emphasis: { color: "#4dcb6c" },
          },
        },
        {
          name: "心悸",
          value: "55",
          itemStyle: {
            normal: { color: "#7cb5ec" },
            emphasis: { color: "#7cb5ec" },
          },
        },
        {
          name: "呼吸困难",
          value: "40",
          itemStyle: {
            normal: { color: "#8085e9" },
            emphasis: { color: "#8085e9" },
          },
        },
        {
          name: "胸痛",
          value: "35",
          itemStyle: {
            normal: { color: "#9AD3FF" },
            emphasis: { color: "#9AD3FF" },
          },
        },
        {
          name: "无症状（仅管理）",
          value: "50",
          itemStyle: {
            normal: { color: "#99ccff" },
            emphasis: { color: "#99ccff" },
          },
        },
      ],
      diseasePieList3: [
        {
          name: "高危",
          value: "120",
          itemStyle: {
            normal: { color: "#ff4500" },
            emphasis: { color: "#ff4500" },
          },
        },
        {
          name: "中危",
          value: "105",
          itemStyle: {
            normal: { color: "#ffa500" },
            emphasis: { color: "#ffa500" },
          },
        },
        {
          name: "低危",
          value: "75",
          itemStyle: {
            normal: { color: "#32cd32" },
            emphasis: { color: "#32cd32" },
          },
        },
      ],
      westernDiagnosis: [
        { name: "血压控制", value: 165, rate: "55.0%" },
        { name: "LDL-C（低密度脂蛋白）", value: 180, rate: "60.0%" },
        { name: "糖化血红蛋白 (HbA1c)", value: 195, rate: "65.0%" },
        { name: "心功能稳定（LVEF）", value: 228, rate: "76.0%" },
      ],
      xAxisWesternList: [],
      yAxisWesternList: [],
      informationList: [],
      pageNo: 1,
      dataListLoading: false,
      total: 0,
    };
  },
  mounted() {
    this.year = new Date().getFullYear().toString();
    if (localStorage.userInfo) {
      this.doctorId = JSON.parse(localStorage.userInfo).id;
    }
    if (localStorage.currentTeam) {
      this.teamsId = JSON.parse(localStorage.currentTeam).id;
      this.getPatientNum();
      this.getPatientNumByMonth();
      this.getCountPatience();
    }
    this.$nextTick(() => {
      this.$refs.mapChart.getMapChart();
    });
    this.$nextTick(() => {
      this.$refs.planPieChart.getCircleChart();
    });
    this.$nextTick(() => {
      this.getDiseasePieChart();
    });
    this.getList();
  },
  methods: {
    fontSizeRem(size) {
      const clientWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      if (!clientWidth) return;
      let fontSize = clientWidth / 1920; //尺寸大小
      return size * fontSize;
    },
    // 改变患者的tab
    changeTab(num) {
      this.activeName = num;
      this.getPatientNumByMonth();
      this.getCountPatience();
    },
    // 获取患者和就诊人数量
    async getPatientNum() {
      this.loading = true;
      const { data: res } = await this.$httpAes({
        url: this.$http.adornUrl("/homePage/selectCountPatience"),
        method: "post",
        data: {
          stringParam1: this.teamsId,
          year: this.year,
          stringParam2: this.doctorId,
        },
      });
      if (res.status) {
        this.loading = false;
        if (res.data && res.data.patientCount && res.data.patientCount.length) {
          for (let key in res.data.patientCount[0]) {
            let obj = {};
            if (key == "thirty") {
              obj.name = "30岁以下";
              obj.index = 1;
            }
            if (key == "forty") {
              obj.name = "30-40岁";
              obj.index = 2;
            }
            if (key == "fifty") {
              obj.name = "40-50岁";
              obj.index = 3;
            }
            if (key == "sixty") {
              obj.name = "50-60岁";
              obj.index = 4;
            }
            if (key == "other") {
              obj.name = "60岁以上";
              obj.index = 5;
            }
            obj.value = res.data.patientCount[0][key];
            this.patientNum.push(obj);
          }
        }
        if (this.patientNum.length) {
          let arr = this.patientNum.sort((a, b) => {
            return a.index - b.index;
          });
          console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!patientNum");
          console.log(arr);
          this.patientNum = arr;
          this.$nextTick(() => {
            this.$refs.pieChart.getCircleChart();
          });
        }
        if (res.data && res.data.visitCount && res.data.visitCount.length) {
          res.data.visitCount.forEach((ele) => {
            let obj = {
              value: ele.number,
            };
            if (ele.visitType == 0) {
              obj.name = "初诊";
            }
            if (ele.visitTypeName) {
              obj.name = ele.visitTypeName;
            }
            this.seeNum.push(obj);
          });
        }
        if (this.seeNum.length) {
          this.$nextTick(() => {
            this.$refs.pieChart2.getCircleChart();
          });
        }
      }
    },
    // 获取患者和就诊人数量
    async getCountPatience() {
      const { data: res } = await this.$httpAes({
        url: this.$http.adornUrl(
          this.activeName == 1
            ? "/homePage/getCountPatience"
            : "/homePage/getCountVisitInfo"
        ),
        method: "post",
        data: {
          stringParam1: this.teamsId,
          stringParam4: this.year,
          stringParam2: this.doctorId,
        },
      });
      if (res.status) {
        this.countPatient = res.data;
        this.countPatient.chainRatio = "0%";
        if (this.countPatient.lastMonth.number) {
          (this.countPatient.chainRatio =
            ((this.countPatient.month.number -
              this.countPatient.lastMonth.number) /
              this.countPatient.lastMonth.number) *
            100).toFixed(2) + "%";
        }
        this.countPatient.commonRatio = "0%";
        if (this.countPatient.lastYearMonth.number) {
          this.countPatient.commonRatio =
            (
              ((this.countPatient.month.number -
                this.countPatient.lastYearMonth.number) /
                this.countPatient.lastYearMonth.number) *
              100
            ).toFixed(2) + "%";
        }
      }
    },
    // 获取患者和就诊人数量
    async getPatientNumByMonth() {
      this.xAxisList = [];
      this.yAxisList = [];
      this.loading = true;
      const { data: res } = await this.$httpAes({
        url: this.$http.adornUrl(
          this.activeName == 1
            ? "/homePage/groupPatience"
            : "/homePage/groupVisitInfo"
        ),
        method: "post",
        data: {
          stringParam1: this.teamsId,
          stringParam3: this.year,
          stringParam2: this.doctorId,
        },
      });
      if (res.status) {
        this.loading = false;
        if (res.data && res.data.length) {
          res.data.forEach((ele) => {
            if (ele.time) {
              ele.timeNum = parseInt(ele.time);
              this.xAxisList.push(this.month[ele.timeNum - 1]);
              this.yAxisList.push(ele.number);
            }
          });
        }
        if (this.xAxisList.length) {
          this.$nextTick(() => {
            this.$refs.barChart.getBarChart();
          });
        }
        console.log(this.xAxisList);
      }
    },
    // 治疗方案头部切换数据
    changePlan(num) {
      this.planCheck = num;
      if (num == 1) {
        this.$nextTick(() => {
          this.$refs.planPieChart.getCircleChart();
        });
      } else {
        let list = [];
        if (num == 2) {
          list = this.medicine;
        }
        if (num == 3) {
          list = this.medicine2;
        }
        if (num == 4) {
          list = this.medicine3;
        }
        if (num == 5) {
          list = this.medicine4;
        }
        list = list.reverse();
        this.xAxisPlanList = list.map((ele) => {
          return ele.value;
        });
        this.yAxisPlanList = list.map((ele) => {
          return ele.name;
        });
        this.$nextTick(() => {
          this.$refs.planBarChart.getBarChart();
        });
      }
    },
    // 疾病诊断
    changeDisease(num) {
      this.diseaseCheck = num;
      if (num == 5) {
        if (this.westernDiagnosis.length) {
          this.xAxisWesternList = this.westernDiagnosis.map((ele) => {
            return ele.name;
          });
          this.yAxisWesternList = this.westernDiagnosis.map((ele) => {
            return ele.value;
          });
        }
        if (this.xAxisWesternList.length) {
          this.$nextTick(() => {
            this.$refs.westernBarChart.getBarChart();
          });
        }
      } else {
        this.$nextTick(() => {
          this.getDiseasePieChart(num);
        });
      }
    },
    getDiseasePieChart(num) {
      let _this = this;
      this.diseasePieChart = this.$echarts.init(
        document.getElementById("diseasePieChart")
      );
      let data = _this.diseasePieList;
      // let data2 = [];
      // if (num == 1) {
      //   data2 = this.diseaseSecPieList;
      // }
      // let data2 = _this.diseaseSecPieList;
      if (num == 2) {
        data = _this.diseasePieList2;
      }
      if (num == 3) {
        data = _this.diseasePieList3;
      }
  
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c} ({d}%)",
        },
        series: [
          {
            type: "pie",
            // selectedMode: "single",
            radius: [0, "100%"],
            center: ["50%", "50%"],
            // color: ["#4dcb6c", "#8085e9", "#7cb5ec",""],
            label: {
              position: "inner",
              fontSize: myEchartsFontSize(14, 1),
              color: "#fff",
            },
            itemStyle: {
              borderRadius: 0,
              borderColor: "#fff",
              borderWidth: myEchartsFontSize(2, 1),
              fontSize: myEchartsFontSize(14, 1),
            },
            labelLine: {
              show: false,
            },
            data: data,
            silent: false,
          },
          // {
          //   type: "pie",
          //   radius: ["40%", "100%"],
          //   center: ["50%", "50%"],
          //   color: [
          //     "#75F394",
          //   ],
          //   // labelLine: {
          //   //   length: 30,
          //   // },
          //   label: {
          //     position: "inner",
          //     fontSize: myEchartsFontSize(14, 1),
          //     color: "#fff",
          //   },
          //   itemStyle: {
          //     borderRadius: 0,
          //     borderColor: "#fff",
          //     borderWidth: myEchartsFontSize(2, 1),
          //     fontSize: myEchartsFontSize(14, 1),
          //   },
          //   labelLine: {
          //     show: false,
          //   },
          //   data: data2,
          // },
          // {
          //   type: "pie",
          //   radius: ["70%", "100%"],
          //   center: ["50%", "50%"],
          //   color: [
          //     "#c6cbff",
          //     "#7ffd9e",
          //     "#a4ddff",
          //     "#9ad3ff",
          //     "#a8adff",
          //     "#9ea3ff",
          //   ],
          //   // labelLine: {
          //   //   length: 30,
          //   // },
          //   label: {
          //     // position: "inner",
          //     fontSize: myEchartsFontSize(14, 1),
          //   },
          //   itemStyle: {
          //     borderRadius: 0,
          //     borderColor: "#fff",
          //     borderWidth: myEchartsFontSize(2, 1),
          //     fontSize: myEchartsFontSize(14, 1),
          //   },
          //   labelLine: {
          //     show: true,
          //   },
          //   data: data3,
          // },
        ],
      };

      this.diseasePieChart.setOption(option);
      // this.diseasePieChart.on("mouseover", (e) => {
      //   console.log(e)
      //   let op = this.diseasePieChart.getOption();
      //   this.diseasePieChart.dispatchAction({
      //     type: "downplay",
      //     seriesIndex: 0,
      //     dataIndex: e.dataIndex,
      //     color: e.color,
      //   });
      //   this.diseasePieChart.setOption(op, true);
      // });
      this.$nextTick(() => {
        // window.onresize = function () {
        //   setTimeout(() => {
        //     _this.diseasePieChart.resize();
        //   }, 100);
        // };
        window.addEventListener("resize", () => {
          if (this.diseasePieChart) {
            this.diseasePieChart.resize();
          }
        });
      });
    },
    getList() {
      let teamsId = "";
      let enertyId = "";
      if (localStorage.currentTeam) {
        teamsId = JSON.parse(localStorage.currentTeam).id;
        enertyId = JSON.parse(localStorage.currentTeam).entityId;
      }
      let userInfo = {};
      if (localStorage.userInfo) {
        userInfo = JSON.parse(localStorage.userInfo);
      }
      this.dataListLoading = true;
      this.$httpAes({
        url: this.$http.adornUrl("/notice/list"),
        method: "post",
        data: {
          intParam1: 8,
          intParam2: this.pageNo,
          stringParam4: teamsId,
          stringParam5: enertyId,
          intParam4: 2, //2资讯
        },
      }).then(({ data }) => {
        if (data.status) {
          let list = [];
          list = data.data;
          this.informationList = list;
          this.total = data.data.totalCount;
        } else {
          this.informationList = [];
        }
        this.dataListLoading = false;
      });
    },
    handleViewInfo(row) {
      this.$router.push({
        name: "informationDetail",
        query: {
          id: row.id,
        },
      });
    },
    toInformation() {
      this.$router.push({
        name: "information",
      });
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
.home-page {
  .block {
    display: flex;
    width: 100%;
    height: 2.9791667rem;
    margin-bottom: 0.125rem;
    .block-item {
      // flex: 1;
      width: 33%;
      margin-right: 1.33%;
      background: #fff;
      position: relative;
      &:last-child {
        margin-right: 0;
      }
      &.block-item-2 {
        width: 67.33%;
      }
      &.block-item-3 {
        // width: 31%;
      }
      .item-title {
        font-size: 0.09375rem;
        height: 0.296875rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 0.125rem;
        border-bottom: 1px solid #eeeeee;
        font-weight: bold;
      }
      .staff-chart {
        display: flex;
        .patient-num {
          width: 50%;
          height: 0.78125rem;
        }
      }
      .month-num {
        padding: 0 0.125rem;
        .tab {
          font-size: 0.0833rem;
          border-bottom: 1px solid #eee;
          display: flex;
          .tab-item {
            padding: 0.041667rem 0;
            margin-right: 0.208333rem;
            position: relative;
            width: 0.33333rem;
            cursor: pointer;
            &.active {
              font-weight: bold;
              color: #1890ff;
            }
            .item-name {
              margin-left: -0.02604167rem;
            }
            .line {
              position: absolute;
              width: 0.25520833rem;
              height: 0.01041667rem;
              background: #1890ff;
              left: 0.015625rem;
              bottom: 0;
            }
          }
        }
        .detail {
          width: 70%;
          overflow: hidden;
          font-size: 0.07291667rem;
          padding-top: 0.07850477rem;
          .detail-item {
            width: 40%;
            float: left;
            margin-right: 0.291667rem;
            margin-bottom: 0.03125rem;
            &:nth-child(2n) {
              margin-right: 0;
            }
            .num {
              padding-left: 0.125rem;
            }
          }
        }
        .month-bar {
          width: 100%;
          height: 1.22395833rem;
          margin-top: 0.1041667rem;
        }
      }
      .area-num {
        width: 100%;
        height: 100%;
      }
      .block-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 0.125rem;
        border-bottom: 1px solid #eeeeee;
        .item-title {
          font-size: 0.09375;
          border-bottom: none;
          font-weight: bold;
          padding: 0;
        }
        .tab-btns {
          display: flex;
          .btn {
            // width: 56px;
            height: 0.171875rem;
            border: 1px solid #e2e2e2;
            padding: 0 0.0842285rem;
            font-size: 0.0625rem;
            display: flex;
            justify-content: center;
            align-items: center;
            border-right: none;
            cursor: pointer;
            &:last-child {
              border-right: 1px solid #e2e2e2;
            }
            &.active {
              background: #009cff;
              color: #fff;
            }
          }
        }
      }
      .plan-chart {
        width: 100%;
        height: 2.6041667rem;
      }
      .echarts-box {
        width: 100%;
        height: 75%;
        padding: 5% 0.125rem 0;
        &.bar-width {
          height: 90%;
        }

        .disease-pie-chart {
          width: 100%;
          height: 100%;
        }
      }
      .information-list {
        padding: 0 0.125rem;
        font-size: 0.07291667rem;
        max-height: 2.6041667rem;
        // overflow-y: scroll;
        .list-item {
          padding-top: 0.078125rem;
          .date {
            padding-bottom: 0.0208333rem;
          }
          .title {
            color: #009cff;
            text-overflow: ellipsis;
            cursor: pointer;
          }
        }
      }
      .more-btn {
        width: 100%;
        color: #999;
        cursor: pointer;
        position: absolute;
        bottom: 0.0520833rem;
        display: flex;
        justify-content: center;
        &:hover {
          color: #009cff;
        }
      }
      .color-list {
        display: flex;
        .list-item {
          .item-bg {
            width: 0.0520833rem;
            height: 0.0520833rem;
            &.item-bg-1 {
              background: #d7f9fe;
            }
            &.item-bg-2 {
              background: #b5e3f8;
            }
            &.item-bg-3 {
              background: #7ebff0;
            }
            &.item-bg-4 {
              background: #4fa1e9;
            }
          }
        }
      }
      .no-data {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #999;
        height: 100%;
      }
    }
  }
}
</style>
